import React from 'react'
import EditarCarga from './EditarCarga'
import EliminarCarga from './EliminarCarga'

function OperacionesDetalleCarga (props) {
  const { data } = props

  return (
    <div style={{ display: 'flex' }}>
      <EditarCarga data={data} />
      <EliminarCarga data={data} />
    </div>
  )
}

export default OperacionesDetalleCarga
